var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFooterSixnetwork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 48,
    viewBox: "0 0 86 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-444.098%",
    y1: "402.459%",
    x2: "289.176%",
    y2: "-120.613%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "16.802%",
    y1: "128.512%",
    x2: "83.514%",
    y2: "-29.26%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-52.195%",
    y1: "134.547%",
    x2: "76.152%",
    y2: "28.364%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.618%",
    y1: "81.998%",
    x2: "133.157%",
    y2: "-24.185%",
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h4.918v4.942H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "m0 0 8.068 13.375L0 26.749h6.428l5.048-8.54 5.091 8.54h6.385l-8.281-13.268 4.355-6.978h-6.234L11.59 8.545 6.256 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.392.217S1.381.158.07 6.844A6.772 6.772 0 0 0 0 7.822v.009c0 .562.063 1.243.252 2.022v.001c.928 3.505 3.548 5.084 5.165 5.742a5.95 5.95 0 0 0 1.863.423h5.829s2.869.065 2.869 2.883c.064 2.32-2.46 2.602-2.46 2.602H1.483v5.245h12.12c1.372-.082 6.216-.758 7.483-6.192.073-.435.113-.899.113-1.395 0-7.435-6.666-8.475-6.666-8.475H7.09S5.192 9.95 5.192 7.934s2.092-2.688 2.092-2.688h12.879V0L7.393.217z",
    id: "h"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.547 15.926c.154 0 .276.129.276.293 0 .163-.122.292-.276.292-.155 0-.277-.129-.277-.292 0-.164.122-.293.277-.293M59.23 14.332c0-.624-.476-1.135-1.071-1.135-.589 0-1.064.51-1.078 1.135v2.029c-.007.03-.014.06-.036.083a.15.15 0 0 1-.127.067h-.043a.189.189 0 0 1-.113-.097c-.008-.008-.008-.016-.008-.023 0-.007-.007-.015-.007-.015v-3.359c0-.098.071-.18.17-.18.093 0 .164.082.164.18v.353a1.379 1.379 0 0 1 1.078-.534c.78 0 1.411.676 1.411 1.496v1.999c0 .105-.078.18-.17.18-.092 0-.17-.075-.17-.18v-2zM61.209 14.384h2.63c-.113-.691-.666-1.195-1.304-1.195-.653 0-1.199.496-1.326 1.195m-.362.293c0-1.022.752-1.848 1.688-1.848.893 0 1.603.751 1.673 1.713v.03a.165.165 0 0 1-.17.166h-2.85c.035.804.63 1.413 1.347 1.413.46 0 .886-.256 1.12-.67a.16.16 0 0 1 .227-.06c.078.06.107.166.057.256-.298.504-.816.834-1.404.834-.936 0-1.688-.826-1.688-1.834M66.343 13.009c0 .09-.085.18-.17.18h-.447v2.683c0 .18.17.271.256.271.085 0 .177.098.177.188s-.092.18-.177.18c-.348 0-.61-.27-.61-.639V13.19h-.433c-.17 0-.17-.09-.17-.18s0-.18.17-.18h.433V11.46c0-.09.085-.18.17-.18.092 0 .184.09.184.18v1.368h.447c.085 0 .17.09.17.18M69.13 16.481c-.035-.015-.056-.045-.07-.083l-1.305-3.291a.188.188 0 0 1 .085-.233.164.164 0 0 1 .22.097l1.156 2.901.801-2.021a.187.187 0 0 1 .163-.113.19.19 0 0 1 .17.113l.802 2.021 1.149-2.9c.035-.09.142-.136.22-.098a.184.184 0 0 1 .092.233l-1.298 3.276a.204.204 0 0 1-.064.09c-.028.023-.057.038-.085.038h-.035c-.057-.007-.121-.052-.135-.113l-.007-.007-.809-2.037-.801 2.03s-.007.007-.007.014a.168.168 0 0 1-.15.113.197.197 0 0 1-.063-.015c-.014 0-.021-.007-.028-.015M75.38 16.15c.708 0 1.304-.66 1.304-1.48s-.596-1.488-1.305-1.488-1.305.669-1.305 1.488c0 .82.596 1.48 1.305 1.48m0-3.321c.915 0 1.645.841 1.645 1.841s-.73 1.841-1.645 1.841c-.908 0-1.645-.841-1.645-1.841s.737-1.841 1.645-1.841M78.188 13.017c0-.106.078-.18.177-.18.085 0 .163.074.163.18v.811c.015-.03.029-.06.05-.09.262-.436.723-.902 1.39-.902.092 0 .17.075.17.18 0 .098-.078.18-.17.18-.454 0-.766.271-1.007.602-.234.33-.369.707-.418.857-.015.03-.015.045-.015.06v1.616c0 .105-.078.18-.163.18a.175.175 0 0 1-.177-.18v-3.314zM81.301 11.43c0-.097.078-.18.17-.18.1 0 .178.083.178.18v3.54l2.057-2.171c.07-.076.17-.076.24 0a.18.18 0 0 1 0 .255l-1.34 1.42 1.348 1.737a.197.197 0 0 1-.014.263.172.172 0 0 1-.114.037c-.05 0-.106-.015-.134-.067l-1.334-1.706-.709.751v.842a.18.18 0 0 1-.177.18c-.093 0-.17-.082-.17-.18v-4.9z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.425 16.33c.06-.06.062-.19-.002-.253-.063-.064-.197-.067-.258-.007-.058.06-.234.114-.36-.002l-.251.252c.258.252.628.255.87.01M49.072 14.61l-.544-.399 4.694-6.46.544.399zM53.315 23.701l-4.684-6.447.543-.398 4.685 6.447z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.077 4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.46 3.882a1.407 1.407 0 0 1-1.404-1.41c0-.78.628-1.411 1.403-1.411s1.404.631 1.404 1.41c0 .78-.629 1.41-1.404 1.41M2.46 0A2.465 2.465 0 0 0 0 2.471a2.465 2.465 0 0 0 2.46 2.471 2.465 2.465 0 0 0 2.458-2.47A2.465 2.465 0 0 0 2.46 0",
    fill: "#666",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.677 17.03a1.407 1.407 0 0 1-1.404-1.411c0-.78.628-1.41 1.404-1.41.775 0 1.403.63 1.403 1.41 0 .779-.628 1.41-1.403 1.41m0-3.881a2.465 2.465 0 0 0-2.46 2.47 2.465 2.465 0 0 0 2.46 2.472 2.465 2.465 0 0 0 2.459-2.471 2.465 2.465 0 0 0-2.46-2.471M54.536 26.61a1.407 1.407 0 0 1-1.403-1.41c0-.779.628-1.41 1.403-1.41s1.404.631 1.404 1.41c0 .779-.629 1.41-1.404 1.41m0-3.881a2.465 2.465 0 0 0-2.459 2.471 2.465 2.465 0 0 0 2.46 2.471 2.465 2.465 0 0 0 2.458-2.47 2.465 2.465 0 0 0-2.459-2.472",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M22.86 14.68h5.403V9.25h-5.404z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M22.86 36h5.403V17.997h-5.404z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.92 13.25)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    mask: "url(#g)",
    d: "m0 0 8.068 13.375L0 26.749h6.428l5.048-8.54 5.091 8.54h6.385l-8.281-13.268 4.355-6.978h-6.234L11.59 8.545 6.256 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 13.25)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.392.217S1.381.158.07 6.844A6.772 6.772 0 0 0 0 7.822v.009c0 .562.063 1.243.252 2.022v.001c.928 3.505 3.548 5.084 5.165 5.742a5.95 5.95 0 0 0 1.863.423h5.829s2.869.065 2.869 2.883c.064 2.32-2.46 2.602-2.46 2.602H1.483v5.245h12.12c1.372-.082 6.216-.758 7.483-6.192.073-.435.113-.899.113-1.395 0-7.435-6.666-8.475-6.666-8.475H7.09S5.192 9.95 5.192 7.934s2.092-2.688 2.092-2.688h12.879V0L7.393.217z",
    fill: "url(#i)",
    mask: "url(#j)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooterSixnetwork);
export default __webpack_public_path__ + "static/media/logo_footer_sixnetwork.d5780f6f.svg";
export { ForwardRef as ReactComponent };